if (!customElements.get('megamenu-element')) {
  class MegamenuElement extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        items: '[data-image]',
        image: '[megamenu-image-element]',
        spinner: '.megamenu---loader'
      };
      this.init();
    }

    init() {
      const items = this.querySelectorAll(this.selectors.items);
      const imageElement = this.querySelector(this.selectors.image);
      const spinner = this.querySelector(this.selectors.spinner);

      if (!items.length || !imageElement) return;

      // --- Find the first valid image from data attributes ---
      let defaultImage = imageElement.getAttribute('src');
      for (const item of items) {
        const dataImage = item.getAttribute('data-image');
        if (dataImage && !dataImage.includes('no-image') && dataImage.trim() !== '') {
          defaultImage = dataImage;
          break;
        }
      }

      // Show first available image
      imageElement.src = defaultImage;
      let currentImage = defaultImage;

      // --- Hover logic ---
      items.forEach(item => {
        item.addEventListener('mouseenter', () => {
          const newImageUrl = item.getAttribute('data-image');

          // Ignore invalid or "no-image" URLs
          if (!newImageUrl || newImageUrl.includes('no-image') || newImageUrl.trim() === '') return;

          if (newImageUrl === currentImage) return;

          if (spinner) spinner.classList.remove('hidden');

          const temp = new Image();
          temp.src = newImageUrl;
          temp.onload = () => {
            imageElement.src = newImageUrl;
            currentImage = newImageUrl;
            if (spinner) spinner.classList.add('hidden');
          };
          temp.onerror = () => {
            // Keep showing the last valid image
            if (spinner) spinner.classList.add('hidden');
            imageElement.src = currentImage || defaultImage;
          };
        });
      });
    }
  }

  customElements.define('megamenu-element', MegamenuElement);
}

